<template>
  <b-row  id="header" style="margin-top: 25px">
    <b-col cols="2" offset="1">
      <b-avatar
          icon="star-fill"
          size="5em"
          :src="imgURL"
          rounded
          variant="warning"
          style="padding:5px"
      />
    </b-col>
    <b-col style="alignment: left">
      <b-row>
        <b-col>
          <h2>{{ name }}</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>Edit, manager and share photos</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>{{ company}}</h6>
        </b-col>
      </b-row>
      <hr />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "MyApp_DetailView_Header",
  components: {},
  props: {
    tool: {
      type: Object,
      default: () => {return {}}
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  data() {
    return {
      name: this.tool ? this.tool.name: '',
      imgURL: this.tool ? this.tool.imgURL: null,
      description: this.tool ? this.tool.description: ''
    }
  }
}
</script>
<style lang="scss" scoped></style>
